export class SearchInfoLocation {
    districtFullName: string;
    districtId?: number;
    districtName: string;
    id?: number;
    provinceFullName: string;
    provinceId?: number;
    provinceName: string;
    wardFullName: string;
    wardId?: number;
    wardName: string;
}